<script setup lang="ts">
    import { computed, toRef } from 'vue'

    import type { PanelOpenerViewModel } from '@Evaluation/Estimations/Components/PanelOpener'

    // ---------------- props / emits ----------------

    const props = defineProps<{
        viewModel: PanelOpenerViewModel
    }>()

    const emit = defineEmits<{
        (e: 'show-links', surveyId: number): void
        (e: 'open-panel', surveyId: number): void
    }>()

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- computed ----------------

    const opened = computed(() => vm.value?.opened)
    const surveyId = computed(() => vm.value.surveyId)

    // ---------------- actions ----------------

    function showAccessLinks()
    {
        emit('show-links', surveyId.value)
    }

    function openPanel()
    {
        emit('open-panel', surveyId.value)
    }

    function close()
    {
        vm.value.close()
    }
</script>


<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Opening a survey</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <p class="lead">
                            You're about to open the survey.
                        </p><br />

                        <table class="table">
                            <tbody>
                                <tr>
                                    <td>
                                        <h5>Access links</h5>
                                        <p>These links will let your respondents access the survey with just one click. Why not (re)send them now?​</p>
                                    </td>
                                    <td class="align-middle">
                                        <button class="btn btn-outline-secondary btn-block text-nowrap" @click="showAccessLinks">Access links</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="modal-footer">
                        <button @click="openPanel" type="button" class="btn btn-primary">Open the survey</button>
                        <button @click="close" type="button" class="btn btn-outline-secondary">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>